import { useProjectContext } from '~/hooks';
import WorksheetForm from '../../../../worksheets/common/components/WorksheetForm';
import ProductionValidationInfo from './ProductionValidationInfo';
import ProductionValidationOptions from './ProductionValidationOptions';
import ProductionValidationTable from './ProductionValidationTable';
import ProductionValidationEstimateButton from './ProductionValidationEstimateButton';
import './styles.scss';

export default function ProductionValidation() {
  const { project, projectDisplayValues } = useProjectContext();

  return (
    <div className="production-validation">
      <ProductionValidationInfo />
      <WorksheetForm>
        <ProductionValidationOptions />
        <ProductionValidationTable project={project} />
        <ProductionValidationEstimateButton project={project} values={projectDisplayValues} />
      </WorksheetForm>
    </div>
  );
}
